import { postJson } from '@/api/index'
import { encryptQueryRequest, decryptQueryResponse } from '@/utils/crypto-js'

export function getCaptcha() {
  return postJson('/Securitycheck/SecuritycheckCode/getCaptcha', new FormData())
}

async function search(type, path, params) {
  var requestBody = encryptQueryRequest(type, params.token, params.codeNum, params.captcha)
  var data = await postJson(path, requestBody, { headers: { 'Content-Type': 'application/json' } })
  return decryptQueryResponse(data, params.token)
}

export function searchCode(params) {
  return search('code', '/Securitycheck/SecuritycheckCode/searchCode', params)
}

export function searchPgCode(params) {
  return search('pg', '/Securitycheck/SecuritycheckCode/searchPgCode', params)
}
